import { useContext, useMemo, useState } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import PersonalDetails from "../PersonalDetails";
import PersonalDocumentsApproved from "../PersonalDocumentsApproved";
import FtmSkills from "../FtmSkills";
import { Context } from "../../Provider";
import gpsTrackerSteps from "../gpsTrackerSteps";

export default function History() {
    const { identificationDetails } = useContext(Context);

    const [expanded, setExpanded] = useState(false);

    const lastStepKey =
        identificationDetails?.last_approval_process_step?.ftm_approval_process_step
            ?.ftm_approval_process_step_key;

    const accordionItems = useMemo(() => {
        const items = [];
        const isGpsStep = gpsTrackerSteps.includes(lastStepKey);

        if (
            ["ALL_PERSONAL_DETAILS_APPROVED", "ALL_PERSONAL_DOCUMENTS_APPROVED"].includes(
                lastStepKey
            ) ||
            isGpsStep
        ) {
            items.push({
                title: "Personal Details",
                content: <PersonalDetails isHistory />,
            });
        }

        if (lastStepKey === "ALL_PERSONAL_DOCUMENTS_APPROVED" || isGpsStep) {
            items.push({
                title: "Personal Documents",
                content: <PersonalDocumentsApproved isHistory />,
            });
        }

        if (isGpsStep) {
            items.push({
                title: "Certificates Documents",
                content: <FtmSkills isHistory />,
            });
        }

        return items;
    }, [lastStepKey]);

    if (!accordionItems.length) return null;

    const handleChange = (panel) => (_, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div className="card">
            <div className="card-body px-3 pt-4 pb-4">
                {accordionItems.map(({ title, content }, index) => {
                    const panelId = `panel-${index}`;

                    return (
                        <Accordion
                            key={title}
                            expanded={expanded === panelId}
                            onChange={handleChange(panelId)}
                            disableGutters
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`${panelId}-content`}
                                id={`${panelId}-header`}
                            >
                                <Typography component="span" sx={{ fontWeight: 500 }}>
                                    {title}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>{content}</AccordionDetails>
                        </Accordion>
                    );
                })}
            </div>
        </div>
    );
}